import React from "react";
import { connect } from "react-redux";
import * as _ from "lodash";

import { Link, st, FormControl } from "lib/index";

const COLUMNS = _.fromPairs(
  [
    {
      id: "total_amount",
      label: () => I18n.humanAttributeName("order", "total_amount"),
      value: [(o) => st.formatMoney(o.total_amount_sum)],
      totalSummaryValue: (orders) => st.formatMoney(st.MoneySum.sum(...orders.map((o) => o.total_amount_sum))),
    },
    {
      id: "agent_commision",
      label: () => I18n.humanAttributeName("order", "agent_commision"),
      value: [(o) => st.formatMoney(o.agent_commision_amount) || "-"],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.sum(
            ...orders.map((o) =>
              o.agent_commision_amount ? [o.agent_commision_amount] : [{ value: 0, currency: o.product_price_currency }]
            )
          )
        ),
    },
    {
      id: "agent_service_fee",
      label: () => I18n.humanAttributeName("order", "agent_service_fee"),
      value: [(o) => st.formatMoney(o.agent_service_fee_amount) || "-"],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.sum(
            ...orders.map((o) =>
              o.agent_service_fee_amount
                ? [o.agent_service_fee_amount]
                : [{ value: 0, currency: o.product_price_currency }]
            )
          )
        ),
    },
    {
      id: "agent_received_amount",
      label: () => I18n.t("papp.finances.FinancesListView.agent_received_paid_th"),
      value: [
        (o) => st.formatMoney(o.agent_received_amount_sum, o.agent_received_transaction_amount_sum) || "-",
        (o) => st.formatMoney(o.agent_paid_amount_sum, o.agent_paid_transaction_amount_sum) || "-",
      ],
      subSummaryValue: [
        (orders) =>
          st.formatMoney(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.agent_received_amount_sum.length
                  ? o.agent_received_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            ),
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.agent_received_transaction_amount_sum.length
                  ? o.agent_received_transaction_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
        (orders) =>
          st.formatMoney(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.agent_paid_amount_sum.length
                  ? o.agent_paid_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            ),
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.agent_paid_transaction_amount_sum.length
                  ? o.agent_paid_transaction_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
      ],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.invert(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.agent_outcome_sum.length ? o.agent_outcome_sum : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
          st.MoneySum.invert(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.agent_real_outcome_sum.length
                  ? o.agent_real_outcome_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          )
        ),
    },
    {
      id: "agent_remaining_received_amount",
      label: () => I18n.humanAttributeName("order", "agent_remaining_received_amount"),
      value: [(o) => st.formatMoney(o.agent_balance_sum) || "-"],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.sum(
            ...orders.map((o) =>
              o.agent_balance_sum.length ? o.agent_balance_sum : [{ value: 0, currency: o.product_price_currency }]
            )
          )
        ),
    },
    {
      id: "socialtravel_received_amount",
      label: () => I18n.t("papp.finances.FinancesListView.socialtravel_received_paid_th"),
      value: [
        (o) =>
          st.formatMoney(o.socialtravel_received_amount_sum, o.socialtravel_received_transaction_amount_sum) || "-",
        (o) => st.formatMoney(o.socialtravel_paid_amount_sum, o.socialtravel_paid_transaction_amount_sum) || "-",
      ],
      subSummaryValue: [
        (orders) =>
          st.formatMoney(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.socialtravel_received_amount_sum.length
                  ? o.socialtravel_received_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            ),
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.socialtravel_received_transaction_amount_sum.length
                  ? o.socialtravel_received_transaction_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
        (orders) =>
          st.formatMoney(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.socialtravel_paid_amount_sum.length
                  ? o.socialtravel_paid_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            ),
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.socialtravel_paid_transaction_amount_sum.length
                  ? o.socialtravel_paid_transaction_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
      ],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.invert(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.socialtravel_outcome_sum.length
                  ? o.socialtravel_outcome_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
          st.MoneySum.invert(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.socialtravel_real_outcome_sum.length
                  ? o.socialtravel_real_outcome_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          )
        ),
    },
    {
      id: "socialtravel_remaining_received_amount",
      label: () => I18n.humanAttributeName("order", "socialtravel_remaining_received_amount"),
      value: [(o) => st.formatMoney(o.socialtravel_balance_sum) || "-"],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.sum(
            ...orders.map((o) =>
              o.socialtravel_balance_sum.length
                ? o.socialtravel_balance_sum
                : [{ value: 0, currency: o.product_price_currency }]
            )
          )
        ),
    },
    {
      id: "supplier_outcome",
      label: () => I18n.humanAttributeName("order", "supplier_outcome"),
      value: [(o) => st.formatMoney(o.supplier_earnings_sum) || "-"],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.sum(
            ...orders.map((o) =>
              o.supplier_earnings_sum.length
                ? o.supplier_earnings_sum
                : [{ value: 0, currency: o.product_price_currency }]
            )
          )
        ),
    },
    {
      id: "supplier_received_amount",
      label: () => I18n.t("papp.finances.FinancesListView.supplier_received_paid_th"),
      value: [
        (o) => st.formatMoney(o.supplier_received_amount_sum, o.supplier_received_transaction_amount_sum) || "-",
        (o) => st.formatMoney(o.supplier_paid_amount_sum, o.supplier_paid_transaction_amount_sum) || "-",
      ],
      subSummaryValue: [
        (orders) =>
          st.formatMoney(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.supplier_received_amount_sum.length
                  ? o.supplier_received_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            ),
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.supplier_received_transaction_amount_sum.length
                  ? o.supplier_received_transaction_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
        (orders) =>
          st.formatMoney(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.supplier_paid_amount_sum.length
                  ? o.supplier_paid_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            ),
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.supplier_paid_transaction_amount_sum.length
                  ? o.supplier_paid_transaction_amount_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
      ],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.invert(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.supplier_outcome_sum.length
                  ? o.supplier_outcome_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          ),
          st.MoneySum.invert(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.supplier_real_outcome_sum.length
                  ? o.supplier_real_outcome_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          )
        ),
    },
    {
      id: "supplier_remaining_received_amount",
      label: () => I18n.humanAttributeName("order", "supplier_remaining_received_amount"),
      value: [(o) => st.formatMoney(st.MoneySum.invert(o.agent_balance_sum)) || "-"],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.invert(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.agent_balance_sum.length ? o.agent_balance_sum : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          )
        ),
    },
    {
      id: "customer_remaining_paid_amount",
      label: () => I18n.humanAttributeName("order", "customer_remaining_paid_amount"),
      value: [(o) => st.formatMoney(st.MoneySum.invert(o.customer_balance_sum)) || "-"],
      totalSummaryValue: (orders) =>
        st.formatMoney(
          st.MoneySum.invert(
            st.MoneySum.sum(
              ...orders.map((o) =>
                o.customer_balance_sum.length
                  ? o.customer_balance_sum
                  : [{ value: 0, currency: o.product_price_currency }]
              )
            )
          )
        ),
    },
  ].map((column) => [column.id, column])
);

const COLUMNS_PER_VIEW_MODE = {
  supplier: [
    COLUMNS.total_amount,
    COLUMNS.agent_commision,
    COLUMNS.agent_service_fee,
    COLUMNS.supplier_outcome,
    COLUMNS.agent_received_amount,
    COLUMNS.socialtravel_received_amount,
    COLUMNS.supplier_received_amount,
    COLUMNS.socialtravel_remaining_received_amount,
    COLUMNS.agent_remaining_received_amount,
    COLUMNS.customer_remaining_paid_amount,
  ],
  agent: [
    COLUMNS.total_amount,
    COLUMNS.agent_commision,
    COLUMNS.agent_service_fee,
    COLUMNS.supplier_outcome,
    COLUMNS.agent_received_amount,
    COLUMNS.supplier_received_amount,
    COLUMNS.supplier_remaining_received_amount,
    COLUMNS.customer_remaining_paid_amount,
  ],
  st_agent: [
    COLUMNS.total_amount,
    COLUMNS.agent_commision,
    COLUMNS.agent_service_fee,
    COLUMNS.supplier_outcome,
    COLUMNS.agent_received_amount,
    COLUMNS.socialtravel_received_amount,
    COLUMNS.supplier_received_amount,
    COLUMNS.socialtravel_remaining_received_amount,
    COLUMNS.supplier_remaining_received_amount,
    COLUMNS.customer_remaining_paid_amount,
  ],
};

@connect((state) => ({
  currentCompanyId: state.auth.company.model.id,
}))
export default class FinancesListTable extends React.PureComponent {
  get dataColumns() {
    return COLUMNS_PER_VIEW_MODE[this.props.viewMode];
  }

  renderToggleAllSelect() {
    const { orders, selectedOrdersIds } = this.props;
    const handleChange = (checked) => {
      this.props.onSelectOrders(
        _.pull(selectedOrdersIds, ...orders.map((o) => o.id)).concat(checked ? orders.map((o) => o.id) : [])
      );
    };
    return (
      <FormControl.Checkbox
        checked={orders.filter((o) => selectedOrdersIds.includes(o.id)).length === orders.length}
        onChange={handleChange}
      />
    );
  }

  renderToggleSelect(order) {
    const { selectedOrdersIds } = this.props;
    const handleChange = (checked) => {
      this.props.onSelectOrders(selectedOrdersIds.filter((id) => id !== order.id).concat(checked ? [order.id] : []));
    };
    return <FormControl.Checkbox checked={selectedOrdersIds.includes(order.id)} onChange={handleChange} />;
  }

  renderHeaders() {
    return [
      <tr key="headers-row1">
        {this.props.selectable && (
          <th rowSpan={2} className="center aligned">
            {this.renderToggleAllSelect()}
          </th>
        )}
        {this.props.viewMode !== "supplier" && (
          <th className="center aligned">{I18n.humanAttributeName("order", "supplier")}</th>
        )}
        {this.props.viewMode === "supplier" && (
          <th className="center aligned">{I18n.humanAttributeName("order", "agent")}</th>
        )}
        {this.dataColumns.map((column) => (
          <th key={column.id} rowSpan={2} colSpan={column.value.length} className="center aligned">
            {column.label()}
          </th>
        ))}
      </tr>,
      <tr key="headers-row2">
        <th className="center aligned u-tdForceBorderLeft">{I18n.t("attributes.order")}</th>
      </tr>,
    ];
  }

  renderBody() {
    return this.props.orders.map((o) => [
      <tr key={`order${o.id}-row1`}>
        {this.props.selectable && <td rowSpan={2}>{this.renderToggleSelect(o)}</td>}
        {this.props.viewMode !== "supplier" && (
          <td className="u-whiteSpaceNowrap">{o.supplier ? o.supplier.name : "-"}</td>
        )}
        {this.props.viewMode === "supplier" && <td className="u-whiteSpaceNowrap">{o.agent ? o.agent.name : "-"}</td>}
        {this.dataColumns.map((column) =>
          column.value.map((valueFn, i) => (
            <td key={`${column.id}-${i}`} rowSpan={2} className="u-whiteSpaceNowrap">
              {valueFn(o)}
            </td>
          ))
        )}
      </tr>,
      <tr key={`order${o.id}-row2`}>
        <td className="u-tdForceBorderLeft u-whiteSpaceNowrap">
          <div>
            <Link to={`/c/${this.props.currentCompanyId}/orders/${o.id}/${o.token}`}>#{o.id}</Link>
            &nbsp;
            {o.customer_display_name} (
            <span className="with-icon">
              <span className="text">{o.persons_count}</span>
              <i className="icon material-icons">people</i>
            </span>
            )
          </div>
          {o.stock_starts_at && (
            <div>
              {st.formatTimeRange(o.stock_starts_at, o.stock_ends_at, {
                includeTime: o.stock_includes_time,
                format: "short",
              })}
            </div>
          )}
          {o.stock_useby_starts_at && (
            <div>
              {I18n.humanAttributeName("order", "stock_useby_time_range")}:{" "}
              {st.formatTimeRange(o.stock_useby_starts_at, o.stock_useby_ends_at, {
                format: "short",
                includeTime: false,
              })}
            </div>
          )}
        </td>
      </tr>,
    ]);
  }

  renderSummary() {
    const total_persons_count = this.props.orders.reduce((sum, o) => sum + o.persons_count, 0);
    return [
      <tr key="summary-1">
        <th colSpan={this.props.selectable ? 2 : 1} rowSpan={2}>
          {I18n.t("papp.finances.FinancesListView.summary_row", {
            start: this.props.start,
            end: this.props.end,
          })}
          <br />
          {I18n.t("base.x_orders", {
            count: this.props.orders.length,
          })}{" "}
          (
          <span className="with-icon">
            <span className="text">{total_persons_count}</span>
            <i className="icon material-icons">people</i>
          </span>
          )
        </th>
        {this.dataColumns.map((column) =>
          column.subSummaryValue ? (
            column.subSummaryValue.map((valueFn, i) => (
              <th key={`${column.id}-${i}`} rowSpan={1}>
                {valueFn(this.props.orders)}
              </th>
            ))
          ) : (
            <th key={column.id} colSpan={column.value.length} rowSpan={2}>
              {column.totalSummaryValue(this.props.orders)}
            </th>
          )
        )}
      </tr>,
      <tr key="summary-2">
        {this.dataColumns
          .filter((column) => column.subSummaryValue)
          .map((column) => (
            <th key={column.id} colSpan={column.value.length} rowSpan={1}>
              {column.totalSummaryValue(this.props.orders)}
            </th>
          ))}
      </tr>,
    ];
  }

  render() {
    const headers = this.renderHeaders();
    return (
      <div className="u-overflowXAuto">
        <table className="ui table celled clear unstackable">
          <thead>{headers}</thead>
          <tbody>{this.renderBody()}</tbody>
          <tfoot>
            {headers}
            {this.props.orders.length > 0 && this.renderSummary()}
          </tfoot>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/finances/FinancesListView/FinancesListTable.jsx